import { CollectionViewer } from '@angular/cdk/collections';
import { Directive } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map, switchMap, tap } from 'rxjs/operators';
import { WorkerAgreementService } from 'src/app/data/worker-agreement.service';
import { MandateAgreementWorkedDaysWorkerGridDto } from 'src/app/models/dtos/mandate-agreement-worked-days-grid-dto';
import { IPagedResult } from 'src/app/shared/models/PagedResult';

interface Paging {
  page: number;
  count: number;
  sortingField: string;
  sortingDirection: string;
}

@Directive()
export class MandateAgreementWorkedDaysSource {
  public mandateAgreementWorkedDaysSubject = new BehaviorSubject<Paging>({ page: 1, count: 10, sortingField: 'SharingDate', sortingDirection: 'desc' });
  public mandateAgreementWorkedDays$: Observable<MandateAgreementWorkedDaysWorkerGridDto[]> = this.mandateAgreementWorkedDaysSubject.asObservable().pipe(
    switchMap((paging: Paging) => {
      return this.workerAgreementService
        .getPagedMandateAgreementWorkedDaysByWorkerId(this.workerId, paging.page, paging.count, paging.sortingField, paging.sortingDirection)
        .pipe(
          tap((response) => {
            this.countSubject.next((<IPagedResult<MandateAgreementWorkedDaysWorkerGridDto>>response).Count);
          }),
          map((response) => (<IPagedResult<MandateAgreementWorkedDaysWorkerGridDto>>response).Results),
          catchError(() => of([])),
          finalize(() => this.loadingSubject.next(false)),
        );
    }),
  );

  private countSubject = new BehaviorSubject<number>(0);
  public count$ = this.countSubject.asObservable();
  private loadingSubject = new BehaviorSubject<boolean>(true);
  public loading$ = this.loadingSubject.asObservable();

  constructor(private workerAgreementService: WorkerAgreementService, private workerId: number) { }

  connect(collectionViewer: CollectionViewer): Observable<Paging> {
    return this.mandateAgreementWorkedDaysSubject.asObservable();
  }

  reload(): void {
    this.mandateAgreementWorkedDaysSubject.next(this.mandateAgreementWorkedDaysSubject.value);
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.mandateAgreementWorkedDaysSubject.complete();
    this.loadingSubject.complete();
    this.countSubject.complete();
  }
}
